/*
Controller: Contract

Operations:
  createContract
  getContractNumbersDetail
  getSignedTemplates
  getStaticAgreementTemplate
  getStaticTemplate
  updateContractStatus
  getSignedContract
*/
var Api = require('../config')
var ContractRequestDef = require('../definitions/ContractRequest')

var Contract = (function () {
  /*
  Operation: createContract
  Create Contract
  Parameters:
    bodyRequest: Contract object
  Responses:
    HTTP 200: Valid response
    HTTP 400: Promotion creation failed
    HTTP 403: Operation not permitted
  */
  function createContractContract (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        ContractRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/contract'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getContractNumbersDetail
  Get contract numbers detail
  Parameters:
    contractNumbers: Contract numbers
  Responses:
    HTTP 200: Contract numbers detail with validation status
    HTTP 400: Invalid request
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
  */
  function getContractNumbersDetailContract (contractNumbers) {
    return new Promise(function (resolve, reject) {
      try {
        if (!contractNumbers) {
          throw new Error('contractNumbers: Missing parameter')
        }
        if (contractNumbers && !(typeof contractNumbers === 'string')) {
          throw new Error('contractNumbers: Wrong type: Got "' + (typeof contractNumbers) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['contractNumbers'] = contractNumbers
      var path = '/contractNumbersDetail'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getSignedTemplates
  Get signedContract template
  Parameters:
    foundryId: Id of the foundry
  Responses:
    HTTP 200: HTML Template of Signed Contract
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getSignedTemplatesContract (foundryId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/contract/signedTemplate/{foundryId}'
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getStaticAgreementTemplate
  Get Static Agreement template
  Parameters:
  Responses:
    HTTP 200: HTML Template of Static Agreement
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getStaticAgreementTemplateContract () {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var path = '/contract/staticTemplate'
      Api
        .request({
          url: path,
          method: 'get'
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getStaticTemplate
  Get signedContract template with foundry data
  Parameters:
    foundryId: Id of the foundry
  Responses:
    HTTP 200: HTML Template of Signed Contract with foundry data
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getStaticTemplateContract (foundryId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/contract/staticTemplate/{foundryId}'
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: updateContractStatus
  Get docusign contract status and update
  Parameters:
    contractId: Id of the contract
    bodyRequest: contract object
  Responses:
    HTTP 200: DocuSign contract data
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function updateContractStatusContract (contractId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!contractId) {
          throw new Error('contractId: Missing parameter')
        }
        if (contractId && !(typeof contractId === 'string')) {
          throw new Error('contractId: Wrong type: Got "' + (typeof contractId) + '", but expected: "string"')
        }
        ContractRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/contract/{contractId}'
      path = path.replace('{' + 'contractId' + '}', contractId)
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getSignedContract
  Get signedContract as binary in form of zip file
  Parameters:
    foundryId: Id of the foundry
  Responses:
    HTTP 200: Binary file contain all the agreements
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getSignedContractContract (foundryId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/foundry/{foundryId}/contracts'
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['createContract'] = createContractContract
  ret['getContractNumbersDetail'] = getContractNumbersDetailContract
  ret['getSignedTemplates'] = getSignedTemplatesContract
  ret['getStaticAgreementTemplate'] = getStaticAgreementTemplateContract
  ret['getStaticTemplate'] = getStaticTemplateContract
  ret['updateContractStatus'] = updateContractStatusContract
  ret['getSignedContract'] = getSignedContractContract
  return ret
})()

module.exports = Contract
